import axios from 'axios';
import { Left, Right } from '../../../../shared/core/either';
import { Result } from '../../../../shared/core/result';
import {
    Mode,
    subscriptionByIdUrl,
    subscriptionCancelUrl,
    subscriptionsUrl
} from '../../../../shared/helpers/endPoints';
import { getStoreLocal } from '../../../../shared/helpers/utils';
import { APIResponse } from '../../../../shared/infrastructure/services/api.response';
import { ISubscriptions } from '../../models/subscriptions/subscriptions.model';
import { BaseSubscriptionService } from './base_subscription.service';
import { authService } from '../../../users/services/dependency.injection';
import { ISingleSubscription } from '../../models/subscriptions/single_subscription.model';
import { ICancelSubscriptionDTO } from '../../dtos/cancelSubscriptionDTO';

export class SubscriptionService implements BaseSubscriptionService {
    async getSubscriptions(value: any): Promise<APIResponse<ISubscriptions>> {
        const modeType = getStoreLocal('modeType') as Mode;
        try {
            const response = await axios({
                method: 'GET',
                url: subscriptionsUrl(modeType),
                params: { ...value },
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authService.accessToken()}`
                }
            });

            return new Right(Result.ok(response.data));
        } catch (err: any) {
            const errorMessage =
                err.data.response.message !== undefined ? err.data.response.message : 'something went wrong';
            return new Left(errorMessage);
        }
    }

    async getSubscriptionById(value: string): Promise<APIResponse<ISingleSubscription>> {
        const modeType = getStoreLocal('modeType') as Mode;
        try {
            const response = await axios({
                method: 'GET',
                url: subscriptionByIdUrl(modeType, value),
                headers: {
                    Authorization: `Bearer ${authService.accessToken()}`
                }
            });

            return new Right(Result.ok(response.data));
        } catch (error: any) {
            const message = error?.data?.error?.message;
            const errorMessage = message !== undefined ? message : 'Something went wrong';
            return new Left(errorMessage);
        }
    }

    async cancelSubscription(value: ICancelSubscriptionDTO): Promise<APIResponse<any>> {
        const modeType = getStoreLocal('modeType') as Mode;
        try {
            await axios({
                method: 'POST',
                url: subscriptionCancelUrl(modeType),
                data: value,
                headers: {
                    Authorization: `Bearer ${authService.accessToken()}`
                }
            });

            return new Right(Result.ok('Subscription Successfully Cancelled'));
        } catch (error: any) {
            const message = error?.data?.error?.message;
            const errorMessage = message !== undefined ? message : 'Something went wrong';
            return new Left(errorMessage);
        }
    }
}
